// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./ContactUs.module.css";
// CSS
// Models
import { I_ContactItem } from "../../../Models/interfaces";
// Models
// Services
import { getContactUsItemsService } from "../../../Services/Common/getContactUsItemsService";
// Services
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
import { sliderPlace } from "../../../Images/images";
import ContactCard from "./ContactCard/ContactCard";
import { Fade } from "react-awesome-reveal";
import { toast } from "react-toastify";
// Contexts

const ContactUs = () => {
  const [contactItems, setContactItems] = useState<I_ContactItem[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  //
  const userToken = useContext(UserTokenContext);
  //
  useEffect(() => {
    getContactUsItemsService(userToken)
      .then(({ data }) => {
        setContactItems(data);
        setIsPending(false);
      })
      .catch((err) => {
        setIsPending(false);
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken]);

  return (
    <div className={`${styles.contactUsContainer} mx-4 pt-4`}>
      <img src={sliderPlace} alt="" className="rounded-2xl" />
      <h1 className="w-full text-center mt-8 text-2xl">تماس با ما</h1>
      <div className={`${styles.row} w-full mt-4`}></div>
      {isPending ? (
        <p className="w-full text-center text-2xl mt-20">
          در حال دریاف اطلاعات
        </p>
      ) : (
        <>
          <Fade>
            <div
              className={`${styles.contactsContent} flex flex-col items-center justify-start`}
            >
              {contactItems.map((item) => (
                <ContactCard key={item.id} data={item} />
              ))}
            </div>
          </Fade>
        </>
      )}
    </div>
  );
};

export default ContactUs;
